<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="nudge"
    transition="scale-transition"
    :offset-y="offsetY"
    min-width="auto"
    :disabled="isReadOnly || disabled"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :clearable="clearable"
        :value="formattedDate"
        :label="label"
        :rules="allRules"
        append-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
        :id="id"
        :disabled="isReadOnly || disabled"
        @click:clear="$emit('clear')"
      ></v-text-field>
    </template>
    <v-date-picker
      :disabled="isReadOnly || disabled"
      :value="value"
      @input="
        menu = false;
        $emit('input', $event);
      "
      locale="nl-BE"
      :allowed-dates="allowed"
    ></v-date-picker>
  </v-menu>
</template>

<script lang="ts">
import { Component, Prop, Provide } from 'vue-property-decorator';
import { LocaleMessage } from 'vue-i18n';
import { mixins } from 'vue-class-component';
import TextInputMixin from '@/mixins/inputMixins/subMixins/TextInputMixin';
import RulesMixin from '@/mixins/RulesMixin';

@Component
export default class DatePicker extends mixins(TextInputMixin, RulesMixin) {
  @Prop(Function) readonly allowed: boolean | undefined;
  @Prop(String) readonly id: string | undefined;
  @Prop(String) readonly value: string | undefined;
  @Prop(String) readonly label: string | LocaleMessage | undefined;
  @Prop(Boolean) readonly disabled!: boolean;
  @Prop({ default: 40 }) readonly nudge: string | LocaleMessage | undefined;
  @Prop({ default: true }) readonly offsetY: string | LocaleMessage | undefined;
  @Prop({ default: false }) readonly clearable: string | LocaleMessage | undefined;
  @Prop({ default: Array }) readonly rules!: ((v: string) => string | boolean | LocaleMessage)[];

  @Provide() menu = false;

  get allRules(): ((v: string) => string | boolean | LocaleMessage)[] {
    return [...this.rules, this.$rule.allowedCharacters];
  }

  get formattedDate() {
    if (!this.value) return null;

    const [year, month, day] = this.value.split('-');
    return `${day}/${month}/${year}`;
  }
}
</script>
